// Published Besselian polynomial coefficients for the 12 August 2026 eclipse.
// Kept separate so the point calculations and the optional obscuration overlay
// use exactly the same astronomical model.
export const ECLIPSE_2026_BESSELIAN_ELEMENTS = [
  2461265.2409999967, 18, -4, 4, 0, 0, 0.4755139946937561, 0.5189246424508172,
  -0.00007730033265175329, -0.000008000147709495707, 0.7711830139160156, -0.23017130091647364,
  -0.00012459829889309028, 0.0000037999946287456105, 14.796669960021973, -0.012065038625763308,
  -0.000003000048066689098, 88.74778747558594, 15.00309001297017, 0, 0.537954727448774,
  0.00009389920667255673, -0.000012099978637043367, -0.008141911069063387, 0.0000935009407316191,
  -0.000012099978637043367, 0.004614099336232548, 0.0045910994125276565, 126,
];
